module.exports = __webpack_public_path__ + "static/img/3.3651914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/3.jpg
// module id = yhxi
// module chunks = 0